import { BodyText, BodyTextElement, BodyTextProps } from '@farol-ds/react'
import classNames from 'classnames'
import { useContext } from 'react'

import { PriceContext } from './context'
import styles from './price-title.module.scss'

export type PriceTitleElement = BodyTextElement

export type PriceTitleProps = BodyTextProps

function PriceTitle(props: PriceTitleProps) {
  const { children, className, ...rest } = props
  const { size } = useContext(PriceContext)
  const classes = classNames(
    styles.root,
    {
      [styles[`size${size}`]]: !!size,
    },
    className
  )
  return (
    <BodyText {...rest} size={size} asChild>
      <span className={classes} {...rest}>
        {children}
      </span>
    </BodyText>
  )
}

export default PriceTitle
